import React from 'react';
import { pick, find, propEq } from 'ramda';
import { string, number, func } from 'prop-types';
import ReactMapGL from 'react-map-gl';
import { media } from '../../theme';
import { connect } from 'react-redux';
import { fitBounds } from 'viewport-mercator-project/dist/perspective-mercator-viewport';
import { getCities } from '../../reducers/cities';
import { getViewport, setViewport } from '../../reducers/mapViewport';
import MapControls from './MapControls';

const minCensusMapZoom = parseInt(process.env.REACT_APP_MAPBOX_CENSUS_ZOOM, 10);
const maxCensusMapZoom = minCensusMapZoom + 3;
const minCityMapZoom = 3;
const maxCityMapZoom = +process.env.REACT_APP_MAPBOX_CENSUS_ZOOM - 1;

class MapMain extends React.Component {
  componentDidMount() {
    const {
      selectedCityId,
      viewport,
      cities,
      width,
      height,
      setViewport,
    } = this.props;

    if (!viewport) {
      setViewport(this.getViewport(cities, selectedCityId, width, height));
    }
  }

  componentWillReceiveProps({ selectedCityId, cities, width, height }) {
    if (
      selectedCityId !== this.props.selectedCityId ||
      cities !== this.props.cities
    ) {
      this.props.setViewport(
        this.getViewport(cities, selectedCityId, width, height),
      );
    }
  }

  getViewport = (cities, cityId, width, height) => {
    const cityLocation = cityId ? find(propEq('id', cityId))(cities) : null;
    const zoomLevel = width <= media.mobile.maxWidth ? 10 : 9;
    const smartBounds =
      width <= media.mobile.maxWidth
        ? [[-85, 49.75], [-70, 21.72]]
        : [[-126.4, 49.75], [-65.31, 21.72]];

    return cityLocation
      ? {
          latitude: cityLocation.lat,
          longitude: cityLocation.long,
          zoom: zoomLevel,
        }
      : fitBounds({
          width,
          height,
          bounds: smartBounds,
          padding: 20,
        });
  };

  onViewportChange = viewport =>
    this.props.setViewport(
      // Prop whitelist is needed to restrict map to 2D
      pick(['latitude', 'longitude', 'zoom'], viewport),
    );

  render() {
    const {
      width,
      height,
      children,
      viewport,
      selectedCityId,
      getRef,
      ...rest
    } = this.props;

    if (!viewport) return null;

    return (
      <ReactMapGL
        width={width}
        height={height}
        ref={getRef}
        minZoom={selectedCityId ? minCensusMapZoom : minCityMapZoom}
        maxZoom={selectedCityId ? maxCensusMapZoom : maxCityMapZoom}
        mapStyle={process.env.REACT_APP_MAPBOX_STYLE}
        mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_PUBLIC}
        onViewportChange={this.onViewportChange}
        {...viewport}
        {...rest}
      >
        {children}
        <MapControls onViewportChange={this.onViewportChange} />
      </ReactMapGL>
    );
  }
}

MapMain.propTypes = {
  width: number.isRequired,
  height: number.isRequired,
  getRef: func,
  selectedCityId: string,
};

export default connect(
  state => ({
    cities: getCities(state),
    viewport: getViewport(state),
  }),
  { setViewport },
)(MapMain);



// WEBPACK FOOTER //
// ./src/components/MapPage/MapMain.jsx